var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPidgin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.50005C0.5 11.775 2.6 14.55 5.5 15.575V1.42505C2.6 2.45005 0.5 5.22505 0.5 8.50005ZM15.5 8.50005C15.5 5.22505 13.425 2.45005 10.5 1.42505V15.575C13.425 14.55 15.5 11.775 15.5 8.50005Z",
    fill: "#83BF4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.575C6.275 15.85 7.125 16 8 16C8.875 16 9.725 15.85 10.5 15.575V1.425C9.725 1.15 8.875 1 8 1C7.125 1 6.275 1.15 5.5 1.425V15.575Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPidgin);
export default __webpack_public_path__ + "static/media/pidgin.6de9fac0cec8020800176eeb19536442.svg";
export { ForwardRef as ReactComponent };